<h1 *ngIf="_data.title" [innerHTML]="_data.title"></h1>
<p *ngIf="_data.message" [innerHTML]="_data.message"></p>
<div class="actions">
  <button sui-solid-button varSize="large" (click)="_onOKButtonClick()">
    {{ _data.okButtonLabel || '확인' }}
  </button>
</div>
